import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {API_PATH} from '../../shared/constants';
import {Observable} from 'rxjs';
import {UserStore} from '../state/user.store';
import { GlobalQuestionService } from '../../shared/services/global-question.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  private refreshTokenTimeout;

  constructor(private httpClient: HttpClient, 
    private userStore: UserStore
    ) {
  }

  createPassword(pwd: string): Observable<any> {
    const requestBody = {
      password: pwd
    };

    return this.httpClient.post(API_PATH.CREATE_PASSWORD, requestBody);
  }

  signUp(firstName: string, lastName: string, mobile: string, email: string, pwd: string): Observable<any> {
    const requestBody = {
      firstname: firstName,
      lastname: lastName,
      password: pwd,
      emailaddress: email,
      mobile
    };

    return this.httpClient.post(API_PATH.SIGN_UP, requestBody);
  }

  authenticateLogin(email: string, pwd: string): Observable<any> {
   
    const requestBody = {
      password: pwd,
      username: email
    };

    return this.httpClient.post(API_PATH.LOGIN, requestBody);
  }

  loginVerification(otp: string): Observable<any> {
    const requestBody = {
      otpCode: otp
    };

    return this.httpClient.post(API_PATH.LOGIN_VERIFICATION, requestBody);
  }

  refreshToken(): Observable<any> {
    const userValue = this.userStore.getValue();
    return this.httpClient.post(API_PATH.REFRESH_TOKEN, {refreshToken: userValue?.refresh_token});
  }

  sendSMS(to: string, sms: string): Observable<any> {
    const requestBody = {
      to,
      body: sms
    };

    return this.httpClient.post(API_PATH.SEND_SMS, requestBody);
  }

  sendOTP(token: string, via): Observable<any> {
    const requestBody = {
      token
    };

    return this.httpClient.post(API_PATH.SEND_OTP, requestBody);
  }

  // finding_id 80/86: exchanges the pre-auth token issued by /login (not yet a real session -
  // rejected by every business endpoint) plus the OTP for the real access_token/refresh_token.
  // POST with the OTP in the body, not a GET with token/otp in the URL.
  verifyLoginOtp(preAuthToken: string, otp: string): Observable<any> {
    const headers = new HttpHeaders().set('Authorization', `Bearer ${preAuthToken}`);
    return this.httpClient.post(API_PATH.LOGIN_VERIFY_OTP, {otp}, {headers});
  }

  resendSignUpEmail(): Observable<any> {
    const requestBody = {
      // todo
    };

    return this.httpClient.post(API_PATH.SIGN_UP_EMAIL, requestBody);
  }

  resendCode(): Observable<any> {
    const requestBody = {
      // todo
    };

    return this.httpClient.post(API_PATH.RESEND_CODE, requestBody);
  }

  forgotPassword(email: string): Observable<any> {
    const requestBody = {
      emailAddress: email
    };

    return this.httpClient.post(API_PATH.FORGOT_PASSWORD, requestBody);
  }

  resetPassword(token: string, pwd: string): Observable<any> {
    const requestBody = {
      token,
      password: pwd
    };

    return this.httpClient.post(API_PATH.RESET_PASSWORD, requestBody);
  }

  // helper methods


  public startRefreshTokenTimer(): void {
    // parse json object from base64 encoded jwt token
    const userValue = this.userStore.getValue();
    const jwtToken = JSON.parse(atob(userValue?.access_token?.split('.')[1]));

    // set a timeout to refresh the token a minute before it expires
    const expires = new Date(jwtToken.exp * 1000);
    const timeout = expires.getTime() - Date.now() - (60 * 1000);
    this.refreshTokenTimeout = setTimeout(() => {
      this.refreshToken()
        .subscribe(x => {
          this.userStore.update({
            access_token: x?.access_token,
            refresh_token: x?.refresh_token,
            username: x?.username
          });
          this.startRefreshTokenTimer();
        });
    }, timeout);
  }

  public stopRefreshTokenTimer(): void {
    clearTimeout(this.refreshTokenTimeout);
  }
}
